export default "__VITE_ASSET__BOqWK6yh__"